/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jump_Progress_AnchorInputs */

const en_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Start`)
};

const ar_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بدء سريع`)
};

const de_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellstart`)
};

const es_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio rápido`)
};

const fr_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Départ rapide`)
};

const it_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio rapido`)
};

const ja_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイック開始`)
};

const ko_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 시작`)
};

const pt_br_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início rápido`)
};

const ru_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрый старт`)
};

const th_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มเร็ว`)
};

const tr_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı Başla`)
};

const zh_cn_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速开始`)
};

const zh_tw_jump_progress_anchor = /** @type {(inputs: Jump_Progress_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速開始`)
};

/**
* | output |
* | --- |
* | "Quick Start" |
*
* @param {Jump_Progress_AnchorInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const jump_progress_anchor = /** @type {((inputs?: Jump_Progress_AnchorInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jump_Progress_AnchorInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jump_progress_anchor(inputs)
	if (locale === "ar") return ar_jump_progress_anchor(inputs)
	if (locale === "de") return de_jump_progress_anchor(inputs)
	if (locale === "es") return es_jump_progress_anchor(inputs)
	if (locale === "fr") return fr_jump_progress_anchor(inputs)
	if (locale === "it") return it_jump_progress_anchor(inputs)
	if (locale === "ja") return ja_jump_progress_anchor(inputs)
	if (locale === "ko") return ko_jump_progress_anchor(inputs)
	if (locale === "pt_br") return pt_br_jump_progress_anchor(inputs)
	if (locale === "ru") return ru_jump_progress_anchor(inputs)
	if (locale === "th") return th_jump_progress_anchor(inputs)
	if (locale === "tr") return tr_jump_progress_anchor(inputs)
	if (locale === "zh_cn") return zh_cn_jump_progress_anchor(inputs)
	return zh_tw_jump_progress_anchor(inputs)
});